import _ from 'lodash';
import { BaseModel } from '../lib';
import _renameKeys from '../../lib/snowjs/lodash-mixins/rename-keys';


export default class ComingSoonModel extends BaseModel {

  get dateMomentValue() {
    return this._convertToMomentValue(this.date);
  }
  set dateMomentValue(value) {
    this.date = this._convertToDateString(value);
  }

  get sortIndexIntValue() {
    return this._convertToInteger(this.sort_index);
  }
  set sortIndexIntValue(value) {
    this.sort_index = this._convertIntegerToIntegerString(value);
  }

  toPublishedData() {
    let intKeys = 'id movie_id'.split(' ');
    let obj = _.toPlainObject(this);
    _.each(intKeys, k => {
      _.set(obj, k, _.parseInt(_.get(obj, k)));
    });
    // obj.date = this._convertToMomentValue(obj.date, 'M/D/YYYY');
    delete obj.manager_notes;
    _renameKeys(obj, { comments: 'comment', movie_id: 'movieId', date_label: 'dateLabel' });

    return obj;
  }

}
